import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HistoryService } from 'src/app/service/asn/history.service';
import { ExcelService } from 'src/app/service/excel.service';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common'
import { ExportStateService } from 'src/app/service/export-state.service';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-asn-history',
    templateUrl: './asn-history.component.html',
    styleUrls: ['./asn-history.component.scss'],
    standalone: false
})
export class ASNHistoryComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  userID
  context: any;
  date1 = new Date();
  currentYear = this.date1.getUTCFullYear();
  currentMonth = this.date1.getUTCMonth() + 1;
  currentDate = this.date1.getUTCDate();

  finalMonth
  finalDate

  presentDate
  otherDate

  isAccessible = false;
  today: string;

  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]

  constructor(private readonly router: Router, public datepipe: DatePipe, private readonly excelService: ExcelService, private readonly exportStateService: ExportStateService,
    private readonly historyService: HistoryService, private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);

    this.presentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en')
    this.date1.setMonth(this.date1.getMonth() - 1);

    this.currentYear = this.date1.getUTCFullYear();
    this.currentMonth = this.date1.getUTCMonth();
    this.currentDate = this.date1.getUTCDate();

    this.finalMonth = this.currentMonth < 10 ? "0" + this.currentMonth : this.currentMonth;
    this.finalDate = this.currentDate < 10 ? "0" + this.currentDate : this.currentDate;

    if(this.finalMonth == "00"){ // NOSONAR
      this.finalMonth = "12";
      this.currentYear--;
    }

    this.otherDate = this.currentYear + "-" + this.finalMonth + "-" + this.finalDate;
    this.today = formatDate(new Date(), 'yyyy-MM-dd', 'en')

    this.columnDefs = [
      {
        headerName: "SUPPLIER", field: "supplier", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: "INVOICE", field: "invoiceNumber", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: "SHIPMENT DATE", field: "shipmentDate", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 300, unSortIcon: true, sortable: true, comparator: this.dateComparator
      },
      {
        headerName: "PO", field: "po", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: "LINE", field: "po_line", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 300,
      },
      {
        headerName: "SCHEDULE", field: "po_schedule", width: 250,
      },
      {
        headerName: "BA#", field: "backnum", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 220,
      },
      {
        headerName: "QUANTITY", field: "quantity", width: 200,
      },
      {
        headerName: "KG", field: "kg", width: 150, autoHeight: true
      }];

    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    // this.checkRoles();
    this.RefreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  RefreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.historyService.loadHistoryData(this.presentDate, this.otherDate).subscribe(
      response => {

        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
					this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        this.defaultRowData();
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      const headers = ['SUPPLIER', 'INVOICE_NUMBER', 'SHIPMENT_DATE', 'PO', 'PO_LINE', 'PO_SCHEDULE', 'BACK_NUMBER', 'QUANTITY', 'KG',
        'SHIPMENT_ID', 'SHIPMENT_TYPE_ID', 'SHIPMENT_TYPE', 'SUPPLIER1', 'EMPTY_PACKAGING_KG', 'EMPTY_PACKAGING_VALUE', 'INVOICE_CREATED',
        'INVOICE_ID', 'FREIGHT_TYPE_ID', 'FREIGHT_TYPE', 'SETS', 'QUANTITY_VARIANCE', 'PALLETS', 'GROSS_WEIGHT', 'WEIGHT_VARIANCE', 'NET_WEIGHT',
        'TARE_WEIGHT', 'PART_VALUE', '214', 'IT', 'TE_ID', 'CONTAINER', 'WAYBILL', 'SEAL', 'VESSEL', 'IS_COMPLETE'];
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
        {linkData = this.displayRowData}
      linkData.forEach(e => {
        const obj = {
          supplier: e.supplier,
          invoice: e.invoiceNumber,
          shipDate: e.shipmentDate,
          po: e.po,
          line: e.po_line,
          schedule: e.po_schedule,
          ba: e.backnum,
          quantity: e.quantity,
          kg: e.kg,
          shipmentId: e.shipmentId,
          shipmentTypeId: e.shipmentTypeId,
          shipmentType: e.shipmentType,
          supplier1: e.supplier1,
          emptyPackagingKg: e.emptyPackagingKg,
          EmptyPackagingValue: e.EmptyPackagingValue,
          invoiceCreated: e.invoiceCreated,
          invoiceId: e.invoiceId,
          freightTypeId: e.freightTypeId,
          freightType: e.freightType,
          sets: e.sets,
          quantityVariance: e.quantityVariance,
          pallets: e.pallets,
          grossWeight: e.grossWeight,
          weightVariance: e.weightVariance,
          netWeight: e.netWeight,
          TareWeight: e.TareWeight,
          PartValue: e.PartValue,
          ba214: e.ba214,
          it: e.it,
          teId: e.teId,
          container: e.container,
          waybill: e.waybill,
          seal: e.seal,
          vessel: e.vessel,
          isComplete: e.isComplete,
        };
        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'HISTORY FROM ' + this.otherDate + ' TO ' + this.presentDate, headers);
    }
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }

}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 10) { // NOSONAR
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
